import { colors } from '../colors.js';
export const matchScoreStar = {
    captionColor: colors.text.secondary,
    fillDefaultColor: colors.neutrals['400'],
    fillActiveColor: colors.text.primary,
};
//# sourceMappingURL=match-score.js.map